import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardDatePicker } from '@material-ui/pickers';


function FromDate(props) {
  const { fromDate, handleChange } = props;

  return (
    <>
      <KeyboardDatePicker
        clearable
        value={fromDate}
        onChange={handleChange}
        inputVariant='outlined'
        label='From Date'
        maxDate={new Date()}
        format='dd/MM/yyyy'
      />
    </>
  );
}

FromDate.propTypes = {  
  fromDate: PropTypes.objectOf(Date),
  handleChange: PropTypes.func
}

export default FromDate;
